import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a568ef22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toolbar__content" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__content" }, "Browse report", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mx-4 mt-2" }, "-", -1))
const _hoisted_5 = {
  key: 1,
  class: "d-flex flex-wrap"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title" }, "Report result from : ", -1))
const _hoisted_7 = { class: "text__content mx-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__content" }, "-", -1))
const _hoisted_9 = { class: "text__content mx-2" }
const _hoisted_10 = {
  key: 2,
  style: {"display":"flex"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title" }, "Report result from : ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__subtitle mx-2" }, "No Data", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isBrowseReport == true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.config.startDate,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.config.startDate) = $event)),
            placeholder: "Start date",
            name: "dueDate",
            style: {"width":"150px"},
            class: "mt-2 ms-4"
          }, null, 8, ["modelValue"]),
          _hoisted_4,
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.config.endDate,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.config.endDate) = $event)),
            placeholder: "End date",
            name: "dueDate",
            style: {"width":"150px"},
            class: "mt-2"
          }, null, 8, ["modelValue"])
        ]))
      : (_ctx.originalConfig != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.moment(_ctx.originalConfig.startDate).format("YYYY/MM/DD")), 1),
            _hoisted_8,
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.moment(_ctx.originalConfig.endDate).format("YYYY/MM/DD")), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
  ]))
}